<template>
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" :class="[sizeClass]" class="w-full">
    <circle class="outline" cx="50" cy="50" r="40" />
    <circle class="animation" cx="50" cy="50" r="40" />
  </svg>
</template>

<script>

const sizes = {
  extraSmall: 'size-extra-small',
  small: 'size-small',
  medium: 'size-medium',
  large: 'size-large',
  extraLarge: 'size-extra-large',
};

export default {
  name: 'SpinLoader',
  props: {
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator(value) {
        return Object.keys(sizes).includes(value);
      },
    },
  },
  computed: {
    sizeClass() {
      return sizes[this.size];
    },
  },
};
</script>

<style scoped>

.size-extra-small {
  max-width: 20px;
}
.size-small {
  max-width: 30px;
}
.size-medium {
  max-width: 50px;
}
.size-large {
  max-width: 70px;
}
.size-extra-large {
  max-width: 90px;
}

svg {
  animation: 1s linear infinite svg-animation;
}

@keyframes svg-animation {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg)
  }
}

.outline {
  @apply block;
  @apply stroke-background;
  fill: transparent;
  stroke-width: 15px;
  transform-origin: 50% 50%;
}

 .animation {
   @apply block;
   @apply stroke-foreground;
   fill: transparent;
   stroke-linecap: round;
   stroke-dasharray: 200;
   stroke-dashoffset: 200;
   stroke-width: 15px;
   transform-origin: 50% 50%;
 }
</style>
